import { action } from 'mobx';
import { BaseEditViewStore, BaasicDropdownStore } from 'core/stores';
import { PatientAddModalForm } from 'application/facility-order/forms';
import { SubCategoryService } from "application/product/services";
import {ImportReferenceService} from 'application/import-reference/services';
import {LocalPatientService, PatientService} from 'application/patient/services';
import { toDate } from "core/utils";
import _ from 'lodash';
import { subCategoriesSort } from 'core/utils';

class PatientAddModalViewStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const subCategoryService = new SubCategoryService(rootStore.application.baasic.apiClient);
        const importReferenceService = new ImportReferenceService(rootStore.application.baasic.apiClient);
        const patientService = new PatientService(rootStore.application.baasic.apiClient);
        const localPatientService = new LocalPatientService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'patient-add-modal',
            Form: PatientAddModalForm,
            actions: () => {
                return {
                    create: async (resource) => {
                        const response = await localPatientService.addLocalPatientFromBrightree(resource);
                        return response.data;
                    }
                }
            },
            FormClass: PatientAddModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.facilityOrderId = this.modalParams.data.facilityOrderId;
        this.facilityId = this.modalParams.data.facilityId;
        this.patientStore = new BaasicDropdownStore({
            filterable: true,
        }, {
            fetchFunc: async (term) => {
                const response = await patientService.find({sort: "lastName|asc", rpp: 100, facilityId: this.facilityId, firstOrLastName: term});
                return _.map(response.data.item, item => {
                    return {
                        id: item.brightreeID,
                        name: (item.brightreeID!= null ? (item.brightreeID + " - "):"") + (item.lastName!= null ? item.lastName:"") + (item.firstName != null && item.lastName != null ? ", " : "") + (item.firstName!=null?item.firstName:"")  + " (" + toDate(item.birthDate)+")"                        
                    };
                });
            }
        });

        this.subCategoryStore = new BaasicDropdownStore({}, {
            fetchFunc: async (term) => {
                const subCategorysAbrv = ["G-Tube", "Oral-Supplements", "Enteral", "Respiratory---trachs-supply", "Trach-Tube","Urologicals", "Ostomy-Products", "Wound-Care"];
                const response = await subCategoryService.find({ searchQuery: term, rpp: 100, sort: "itemCategory.name|asc", embed: "ItemCategory"});
                
                let data =  subCategoriesSort(response.data.item.map(i=> {return {...i, name: `${i.name}`}}));
                let filteredSubCategories = _.filter(data, i => {
                    return subCategorysAbrv.some(s => i.abrv === s);
                });

                return filteredSubCategories;
            }
        });

        this.referenceStore = new BaasicDropdownStore({
            filterable: true,
        }, {
            fetchFunc: async(term) => {
                const response = await importReferenceService.find({ searchQuery: term, rpp: 100, isActive: true, sort:"name|asc" });
                return response.data.item;          
             },
             onChange: (value)=>{
                this.form.set({ reference: value });
            }
        });
    }
    @action.bound
    async createResource(resource) {

        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);

        try {

            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create({
                ...resource,
                facilityOrderId: this.facilityOrderId
            });

            this.form.setFieldsDisabled(false);
            this.modalParams.data.fetchTable();
            this.modalParams.close();

            this.rootStore.notificationStore.success('Patient successfully added.');
        } 
        catch(err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error( err && err.data && err.data.errors ? err.data.errors : 'Error occured while trying to add new patient.');
        }
    }
}

export default PatientAddModalViewStore;
